export default "__VITE_ASSET__53i6CNui__"